import apiClient from '@/plugins/apiClient'
let basePath = "/cms/pages";
import qs from 'qs';

export default {
     namespaced: true,
     state:{
          list: [],
          single: null,
          errors: {},
          message: null,
          meta: {
               current_page: 1,
               total: 0,
               per_page: 12
          },
          filters: {
               wheres : []
          },
          components: [],
          classes: [],
     },
     getters:{
          list: state => state.list,
          single: state => state.single,
          message: state => state.message,
          errors: state => state.errors,
          meta: state => state.meta,
          filters: state => state.filters,
          components: state => state.components,
          classes: state => state.classes,
     },
     mutations:{
        error(state, err) {
            state.message = err.response.data.message
            state.errors = err.response.data
        },
        setList(state, resp) {
            state.list = resp.data
        },
        setMeta(state, resp){
          state.meta = resp.meta
        },
        setFilters(state, resp){
          state.filters = resp.filters
        },
        setSingle(state, resp){
               state.single = resp.data
        },
        setComponents(state, resp){
          state.components = resp.data
        },
        setClasses(state, resp){
          state.classes = resp.data
        }
     },
     actions:{
          getList({commit, state}, data){
               return new Promise((resolve, reject) => {
                    
                    let params =  qs.stringify(state.filters, { arrayFormat: 'indices' })
                    apiClient.get(basePath+'?page='+state.meta.current_page+'&'+params).then(resp => {
                         commit('setList', resp.data);
                         commit('setMeta', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          createSingle({commit}, data){
               return new Promise((resolve, reject) => {
                    apiClient.post(basePath+'/create', data).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getSingle({commit}, data){
               return new Promise((resolve, reject) => {
                    apiClient.get(basePath+'/'+data.id).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getComponents({commit}){
               return new Promise((resolve, reject) => {
                    apiClient.get(basePath+'/components').then(resp => {
                         commit('setComponents', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getClasses({commit}){
               return new Promise((resolve, reject) => {
                    apiClient.get(basePath+'/classes').then(resp => {
                         commit('setClasses', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          updateSingle({commit}, data){
               return new Promise((resolve, reject) => {
                    apiClient.patch(basePath+'/'+data.id+'/update',data).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          deleteSingle({commit}, data){
               return new Promise((resolve, reject) => {
                    apiClient.delete(basePath+'/'+data.id+'/delete').then(resp => {
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          autoTranslator({commit}, data){
               return new Promise((resolve, reject) => {
                    apiClient.post(basePath+'/auto-translator', data).then(resp => {
                         resolve(resp);
                         return resp;
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          setAsSingle({state}, data){
               state.single = data;
          },
          setMeta({commit}, data){
               commit('setMeta',{meta:data});
               // commit('success', true);
          },
          setFilters({commit}, data){
               commit('setFilters',{filters:data});
          }
     },
}